import cookie from 'js-cookie';
import type { OS } from 'types';
import type { User } from 'types/User';
import * as uuid from 'uuid';

import braze from '~/services/braze.client';
import facebook from '~/services/facebook';
import facebookPixel from '~/services/facebook.pixel';
import gtm from '~/services/gtm.client';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  legacyId: string;
  os: OS;
  pagePosition: string;
  productName: string;
  user: User;
};

class SetNotificationEvent extends UserEvent<EventData> {
  sendToTikTok() {
    return tiktok.fireEvent('NotifyMeSet');
  }

  async sendToFacebook() {
    const eventId = uuid.v4();

    await facebookPixel.fireCustomEvent(
      facebookPixel.CustomEventNames.NotifyMeSet,
      { eventID: eventId }
    );

    const hashedProfile = await facebook.getHashedProfile(
      this.data.user.profile
    );

    const serverEventData = [
      {
        action_source: 'website',
        event_id: eventId,
        event_name: facebookPixel.CustomEventNames.NotifyMeSet,
        event_time: Math.floor(Date.now() / 1000),
        user_data: {
          client_ip_address: this.data.clientIp,
          client_user_agent: navigator.userAgent,
          external_id: this.data.user.id ?? 'guest',
          fbc: cookie.get('_fbc'),
          fbp: cookie.get('_fbp'),
          ...hashedProfile
        }
      }
    ];

    this.serverEvents.push({ data: serverEventData, type: 'facebook' });
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.NotifyMeSet);
  }

  sendToGtm() {
    gtm.pushToDataLayer({
      event: 'notify_me_set',
      page_position: this.data.pagePosition,
      product_name: this.data.productName
    });
  }

  collectServerEvents() {
    this.serverEvents.push({
      data: { legacy_product_id: this.data.legacyId, os: this.data.os },
      type: 'notification_set'
    });
  }

  sendToBraze() {
    braze.requestPushPermission();
  }
}

export default SetNotificationEvent;
